// extracted by mini-css-extract-plugin
export var filterIncDec = "_c4-0";
export var leftBorder = "_c4-1";
export var rightBorder = "_c4-2";
export var stringInput = "_c4-3";